var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectronicInvoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Electronic_invoice_-_Flaticon-2",
    "data-name": "Search results for Electronic invoice - Flaticon-2",
    transform: "translate(0.001)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9345",
    "data-name": "Path 9345",
    d: "M18.387,3.226H16.129V0H6.64L3.87,2.77v.456H1.612A1.615,1.615,0,0,0,0,4.839V16.452a1.615,1.615,0,0,0,1.613,1.613H5.483v1.29H4.193V20H15.806v-.645h-1.29v-1.29h3.871A1.615,1.615,0,0,0,20,16.452V4.839a1.615,1.615,0,0,0-1.613-1.613Zm-.323,12.258H16.129V5.161h1.935Zm-2.581,0H4.516V3.226H7.1V.645h8.387Zm-11.613,0H1.935V5.161H3.87Zm1.1-12.9L6.451,1.1V2.581ZM.645,4.839a.969.969,0,0,1,.968-.968H3.87v.645H1.935a.646.646,0,0,0-.645.645V15.484H.645ZM13.87,19.355H6.129v-1.29H13.87Zm5.484-2.9a.969.969,0,0,1-.968.968H1.612a.969.969,0,0,1-.968-.968v-.323h18.71Zm-.645-.968V5.161a.646.646,0,0,0-.645-.645H16.129V3.871h2.258a.969.969,0,0,1,.968.968V15.484Zm0,0",
    fill: "#cdbfd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9346",
    "data-name": "Path 9346",
    d: "M128,137.677h9.677V128H128Zm.645-7.1h1.935v6.452h-1.935Zm2.581,6.452v-6.452h5.806v6.452Zm5.806-7.1h-5.806v-1.29h5.806Zm-6.452-1.29v1.29h-1.935v-1.29Zm0,0",
    transform: "translate(-122.839 -122.839)",
    fill: "#cdbfd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9347",
    "data-name": "Path 9347",
    d: "M160,208h.645v.645H160Zm0,0",
    transform: "translate(-153.549 -199.613)",
    fill: "#cdbfd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9348",
    "data-name": "Path 9348",
    d: "M224,208h.645v.645H224Zm0,0",
    transform: "translate(-214.968 -199.613)",
    fill: "#cdbfd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9349",
    "data-name": "Path 9349",
    d: "M256,208h3.226v.645H256Zm0,0",
    transform: "translate(-245.678 -199.613)",
    fill: "#cdbfd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9350",
    "data-name": "Path 9350",
    d: "M224,240h4.516v.645H224Zm0,0",
    transform: "translate(-214.968 -230.323)",
    fill: "#cdbfd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9351",
    "data-name": "Path 9351",
    d: "M160,288h.645v.645H160Zm0,0",
    transform: "translate(-153.549 -276.387)",
    fill: "#cdbfd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9352",
    "data-name": "Path 9352",
    d: "M224,288h.645v.645H224Zm0,0",
    transform: "translate(-214.968 -276.387)",
    fill: "#cdbfd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9353",
    "data-name": "Path 9353",
    d: "M256,288h3.226v.645H256Zm0,0",
    transform: "translate(-245.678 -276.387)",
    fill: "#cdbfd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9354",
    "data-name": "Path 9354",
    d: "M224,320h4.516v.645H224Zm0,0",
    transform: "translate(-214.968 -307.097)",
    fill: "#cdbfd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9355",
    "data-name": "Path 9355",
    d: "M248,32h4.839v.645H248Zm0,0",
    transform: "translate(-238 -30.71)",
    fill: "#cdbfd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9356",
    "data-name": "Path 9356",
    d: "M248,64h2.258v.645H248Zm0,0",
    transform: "translate(-238 -61.419)",
    fill: "#cdbfd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9357",
    "data-name": "Path 9357",
    d: "M320,64h1.935v.645H320Zm0,0",
    transform: "translate(-307.097 -61.419)",
    fill: "#cdbfd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9358",
    "data-name": "Path 9358",
    d: "M248,96h4.839v.645H248Zm0,0",
    transform: "translate(-238 -92.129)",
    fill: "#cdbfd3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronicInvoice);
export default __webpack_public_path__ + "static/media/electronic-invoice.caf494a2accedddc8127d4991883c0b3.svg";
export { ForwardRef as ReactComponent };